import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { getUIDateFormat } from 'helpers';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import PropTypes from 'prop-types';

const PSRDatePickerControl = ({
  name,
  title,
  handleDateChange,
  value,
  dateField,
  textValue,
  secondaryElement,
  validators,
  errorMessages,
  isDisabled
}) => (
  <FormViewContent
    className="MuiListItem-react-datepicker"
    primaryText={textValue}
    secondaryText={(
      <>
        <MUIDatePicker
          title={title}
          name={name}
          id={name}
          variant="outlined"
          validators={validators}
          errorMessages={errorMessages}
          className={dateField}
          onChange={handleDateChange}
          value={value ? getUIDateFormat(value) : undefined}
          disabled={isDisabled}
        />
&nbsp;
        {secondaryElement}
      </>
    )}
  />
);

PSRDatePickerControl.propTypes = {
  name: PropTypes.string.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  dateField: PropTypes.string.isRequired,
  textValue: PropTypes.string.isRequired,
  validators: PropTypes.arrayOf(
    PropTypes.string
  ),
  errorMessages: PropTypes.arrayOf(
    PropTypes.string
  ),
  isDisabled: PropTypes.bool.isRequired
};

PSRDatePickerControl.defaultProps = {
  value: '',
  validators: [],
  errorMessages: []
};

export default PSRDatePickerControl;
